export const FOTO = {
  src: "/images/knyerie.png",
  alt: {
    id: "Poster layanan Klinik Nyeri RS Jakarta Medical Center.",
    en: "Pain clinic service poster of Jakarta Medical Center Hospital.",
  },
};

export const KLINIK_NYERI = {
  telepon: [
    {
      label: { id: "Customer Service", en: "Customer Service" },
      tampil: "0811-901-874",
      tel: "+62811901874",
      wa: "62811901874",
      pesanWa: {
        id: "Halo RS Jakarta Medical Center,\n\nSaya ingin melakukan reservasi di Klinik Nyeri.\n\nMohon informasi jadwal dokter dan ketentuannya. Terima kasih.",
        en: "Hello RS Jakarta Medical Center,\n\nI would like to book an appointment at the pain clinic.\n\nPlease let me know the doctor's schedule and requirements. Thank you.",
      },
      utama: true,
    },
    {
      label: { id: "Hunting", en: "Main line" },
      tampil: "(021) 798 0888",
      tel: "+62217980888",
      utama: false,
    },
  ],
};
export const KONDISI = [];
export const KETENTUAN = [];
export const LANGKAH = [
  {
    judul: { id: "Hubungi Customer Service", en: "Contact Customer Service" },
    isi: {
      id: "Sampaikan keluhan Anda dan tanyakan jadwal dokter yang tersedia.",
      en: "Describe your symptoms and ask which doctors are available.",
    },
  },
  {
    judul: { id: "Tentukan jadwal", en: "Choose a time" },
    isi: {
      id: "Petugas mengonfirmasi jadwal konsultasi beserta ketentuan dan biayanya.",
      en: "Our staff will confirm your appointment time, the requirements, and the cost.",
    },
  },
  {
    judul: { id: "Datang sesuai jadwal", en: "Come at the scheduled time" },
    isi: {
      id: "Bawa hasil pemeriksaan sebelumnya apabila ada, seperti rontgen atau MRI.",
      en: "Bring any previous test results you may have, such as X-rays or MRI scans.",
    },
  },
];
